import { getFeatureFlags } from '@noths/polaris-client-feature-flags';
import type { IncomingMessage } from 'http';

export const getFeatureFlagsWithMatchers = (req: IncomingMessage) => {
  return getFeatureFlags(req, {
    collapseFlagNames: [
      { newName: 'browse_provider', oldNameMatcher: /^browse_provider/m },
      { newName: 'site_wide_promo', oldNameMatcher: /^site_wide_promo/m },
    ],
  });
};
